export default {
  google: {
    locationId: null,
    returnTo: null,
    state: null,
  },
  stripe: {
    brandId: null,
    locationId: null,
    state: null,
  },
}
